import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

if (document.getElementsByClassName('gallery')[0]) {
    initGallery();
}

function initGallery() {

    var elem = document.querySelector('.gallery');
    var msnry = new Masonry('.gallery', {
        // options
        itemSelector: '.gallery__item',
        gutter: '.gallery__gap',
        // columnWidth: 80

    });

    imagesLoaded(elem).on('progress', function () {
        // layout Masonry after each image loads
        msnry.layout();
    });
}
